import ConsumersPage from "@/views/Consumers.vue";
import ConsumersList from "@/components/consumers/List.vue";
import ConsumersInfo from "@/components/consumers/Info.vue";
import ConsumersCreate from "@/components/consumers/Create.vue";

const consumers = [
    {
        path: "/consumers",
        component: ConsumersPage,
        children: [
            {
                path: "",
                name: 'ConsumersList',
                component: ConsumersList,
            },
            {
                path: ":id",
                name: "ConsumersInfo",
                component: ConsumersInfo,
                props: true,
              },
              {
                path: "create",
                name: "ConsumersCreate",
                component: ConsumersCreate,
              },

        ]
    },
];

export default consumers;